import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import theme from 'theme'

import useStyles from './styles'

const AuditsStartTodayModal = ({ onConfirm, open, sampling, setOpen }) => {
  const classes = useStyles()

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Iniciar auditoria hoje"
      dialogSize="sm"
      fullWidth
      closeIconButton
      actionButtonText="Salvar e iniciar"
      closeButtonText="Voltar"
      actionButton={onConfirm}
      accentColor={theme.palette.warning.main}
    >
      <Box className={classes.content}>
        <Typography variant="body1">
          Como a data de início é hoje, a auditoria começa assim que você
          salvar: <strong>{sampling}%</strong> dos processos elegíveis serão
          selecionados e seus responsáveis notificados por e-mail.
        </Typography>
        <Typography variant="body1">
          Depois de iniciada, ela não poderá mais ser editada.
        </Typography>
        <Typography variant="body1">
          <strong>Deseja salvar e iniciar a auditoria?</strong>
        </Typography>
      </Box>
    </BaseDialog>
  )
}

AuditsStartTodayModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  sampling: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setOpen: PropTypes.func.isRequired,
}

export default AuditsStartTodayModal
